import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export async function saveUserRole(uid, role) {
  const ref = doc(db, "users", uid);
  await setDoc(ref, { role }, { merge: true });
}

export async function getUserRole(uid) {
  try {
    // Handle case where uid is an object (e.g., user object instead of UID string)
    const uidString = typeof uid === 'object' && uid !== null ? uid.uid || JSON.stringify(uid) : uid;
    
    if (!uidString) {
      console.error('getUserRole called with undefined, null, or invalid uid:', uid);
      return null;
    }
    
    const ref = doc(db, "users", String(uidString));
    const snap = await getDoc(ref);
    
    if (!snap.exists()) {
      console.log(`User document does not exist for UID: ${uidString}`);
      return null;
    }
    
    const userData = snap.data();
    const role = userData?.role || null;
    
    if (!role) {
      console.log(`No role found in user document for UID: ${uidString}`, userData);
    } else {
      console.log(`Retrieved role '${role}' for UID: ${uidString}`);
    }
    
    return role;
  } catch (error) {
    console.error(`Error getting role for user ${uid}:`, error);
    return null;
  }
}

export async function saveUserProfile(uid, data) {
  const ref = doc(db, "users", uid);
  await setDoc(ref, data, { merge: true });
}
